import { Button } from 'antd';
import classNames from 'classnames';
import { CardFooter } from 'components/Card/Card';

export function ApplicationWizardActions({ applicationIsReadOnly, className, backButtonProps, nextButtonProps }) {
  return (
    <CardFooter className={classNames('mt-16 p-7 pb-24 md:pb-7', className)}>
      <div className="flex flex-col-reverse sm:flex-row justify-between gap-2 md:gap-4">
        <Button
          size="large"
          data-testid="back-button"
          {...backButtonProps}
          className={classNames('px-8', backButtonProps?.className)}
          disabled={backButtonProps?.disabled || false}
        >
          Back
        </Button>

        <div />

        <Button
          type="primary"
          size="large"
          htmlType="submit"
          data-testid="next-button"
          {...nextButtonProps}
          className={classNames('px-8', nextButtonProps?.className)}
          disabled={nextButtonProps?.disabled || false}
        >
          {nextButtonProps?.text ?? (applicationIsReadOnly ? 'Next' : 'Save & Next')}
        </Button>
      </div>
    </CardFooter>
  );
}
